import React, { useEffect, useState, useRef } from 'react';
import loadable from '@loadable/component';

import { QuickFilterButton, Button } from '@hpi-sox/hpstellar-core';
import { ChevronDown, ChevronUp } from '@hpi-sox/hpstellar-icons';

import { Helpers } from '../../core/src/helpers';
import { withError } from '../../shared/components/error-boundary';

import './filter-view.less';

const OrionFilterView = loadable(() => Helpers.retryFunc(() => import('./orion/orion-filter-view')));

export default withError(function FilterView({ filters, onSelectFacet, orionEnabled, isMobile }) {
    const ref = useRef(null);
    const [more, setMore] = useState(false);
    const [expand, setExpand] = useState(false);

    useEffect(() => {
        if (!ref.current) return () => {};
        const resizeObserver = new ResizeObserver(() => {
            setMore(ref.current.clientHeight >= 160);
        });
        resizeObserver.observe(ref.current);
        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    // Use Orion version for mobile when enabled
    if (orionEnabled && isMobile) {
        return <OrionFilterView filters={filters} onSelectFacet={onSelectFacet} />;
    }

    return (
        <div className="vwaFiltersView">
            <div className={`vwaFiltersView-list${expand ? ' vwaFiltersView-fullHeight' : ''}`} ref={ref}>
                {filters.map((f, i) => (
                    <QuickFilterButton
                        key={`${f.displayName}-${i}`}
                        onClick={onSelectFacet(f.key, f.urlValue)}
                        isActive
                    >
                        {f.displayName}
                    </QuickFilterButton>
                ))}
            </div>
            {more && (
                <div className="vwaFiltersView-more">
                    <Button
                        onClick={() => setExpand(!expand)}
                        color="dark"
                        variation="tertiary"
                        endIcon={expand ? <ChevronUp size="s" /> : <ChevronDown size="s" />}
                    >
                        {expand ? 'SHOW LESS' : 'SEE ALL APPLIED FILTERS'}
                    </Button>
                </div>
            )}
        </div>
    );
});
